import {
  gridConfig,
} from '@/components/ContractBilling/BaseStore/contractsBase';

export default {
  columns: [
    {
      caption: 'CONTRACT',
      dataField: 'contractName',
      dataType: '',
      area: 'filter',
      expanded: true,
      showTotals: false,
    }, {
      caption: 'CHARGECODE',
      dataField: 'chargeCodeName',
      dataType: '',
      area: 'column',
      expanded: true,
      showTotals: false,
    }, {
      caption: 'DESCRIPTION',
      dataField: 'description',
      dataType: '',
      area: 'filter',
      expanded: true,
      showTotals: false,
    }, {
      caption: 'AREF',
      dataField: 'aref',
      dataType: '',
      area: 'filter',
      expanded: true,
      showTotals: false,
    }, {
      caption: 'METERID',
      dataField: 'meterId',
      dataType: '',
      area: 'filter',
      expanded: true,
      showTotals: false,
    }, {
      caption: 'SCHEDULEID',
      dataField: 'scheduleId',
      dataType: '',
      area: 'filter',
      expanded: true,
      showTotals: false,
    }, {
      caption: 'PRICENODE',
      dataField: 'priceNode',
      dataType: '',
      area: 'filter',
      expanded: true,
      showTotals: false,
    }, {
      caption: 'RESOURCE',
      dataField: 'resource',
      dataType: '',
      area: 'filter',
      expanded: true,
      showTotals: false,
    }, {
      caption: 'TRADINGDATE',
      dataField: 'tradingDate',
      dataType: 'string',
      area: 'row',
      expanded: true,
      showTotals: false,
    }, {
      caption: 'TRADINGHOUR',
      dataField: 'tradingHour',
      dataType: 'number',
      area: 'filter',
      expanded: true,
      showTotals: false,
    }, {
      caption: 'TRADING INTERVAL',
      dataField: 'tradingInterval',
      dataType: '',
      area: 'filter',
      expanded: true,
      showTotals: false,
    }, {
      caption: 'CURRENTAMOUNT',
      dataField: 'currentAmount',
      dataType: '',
      area: 'data',
      summaryType: 'sum',
      expanded: true,
      format: gridConfig.zeroCurrencyFormat,
    }, {
      caption: 'CURRENTQUANTITY',
      dataField: 'currentQuantity',
      dataType: '',
      area: 'data',
      summaryType: 'sum',
      expanded: true,
      format: gridConfig.valFormat,
    }, {
      caption: 'CURRENTPRICE',
      dataField: 'currentPrice',
      dataType: '',
      area: 'data',
      summaryType: 'sum',
      expanded: true,
      format: gridConfig.zeroCurrencyFormat,
    }, {
      caption: 'COMPAREAMOUNT',
      dataField: 'currentAmountCompare',
      dataType: '',
      area: 'data',
      summaryType: 'sum',
      expanded: true,
      format: gridConfig.zeroCurrencyFormat,
      visible: true,
    }, {
      caption: 'COMPAREQUANTITY',
      dataField: 'currentQuantityCompare',
      dataType: '',
      area: 'data',
      summaryType: 'sum',
      expanded: true,
      format: gridConfig.valFormat,
      visible: true,
    }, {
      caption: 'COMPAREPRICE',
      dataField: 'currentPriceCompare',
      dataType: '',
      area: 'data',
      summaryType: 'sum',
      expanded: true,
      format: gridConfig.zeroCurrencyFormat,
      visible: true,
    }, {
      caption: 'VARIANCEAMOUNT',
      dataField: 'varianceAmount',
      dataType: '',
      area: 'data',
      summaryType: 'sum',
      expanded: true,
      format: gridConfig.zeroCurrencyFormat,
      visible: true,
    }, {
      caption: 'VARIANCEQUANTITY',
      dataField: 'varianceQuantity',
      dataType: '',
      area: 'data',
      summaryType: 'sum',
      expanded: true,
      format: gridConfig.valFormat,
      visible: true,
    }, {
      caption: 'VARIANCEPRICE',
      dataField: 'variancePrice',
      dataType: '',
      area: 'data',
      summaryType: 'sum',
      expanded: true,
      format: gridConfig.zeroCurrencyFormat,
      visible: false,
    },
  ],
};